import { gql } from '@apollo/client';

export const GET_USER_FAVORITE_ORGS = gql`
  query getUserFavoriteOrgs {
    getUserFavoriteOrgs {
      isFollowingOrgs
      orgs {
        orgId
        name
        description
        disclaimer
        yearEstablished
        childEnrichmentStatement
        activeFlyersCount
        newFlyersCount
        approvedFlyerCount
        address
        newUnreadFlyersCount
        isFollowing
      }
    }
  }
`;
